import React from 'react';
import Beers from '../sections/BeersSection/BeersSection';
import HeroSection from '../sections/HeroSection/HeroSection';
import Location from '../sections/LocationsSection/LocationsSection';
import OurStory from '../sections/OurStory/OurStory';
import { motion, AnimatePresence } from 'framer-motion';
import Footer from './Footer';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <Beers />
      <AnimatePresence mode='wait'>
        <motion.div
          key='tango'
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50, transition: { duration: 0.5 } }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.3 }} // Delays appearance slightly
          viewport={{ once: false, amount: 0.5 }}
          style={{ willChange: 'transform, opacity' }}
        >
          <OurStory />
        </motion.div>
      </AnimatePresence>
      <Location />
      <Footer />
    </>
  );
}
